<template>
  <b-modal
    v-model="isShow"
    centered
    title="Import file thành công"
    no-close-on-backdrop
    @close="onClose"
  >
    <div class="d-flex justify-content-center align-items-center flex-column">
      <div>
        Số bản ghi thành công <span class="font-bold">{{ successCount }}</span> bản ghi
      </div>
      <div class="mt-1">
        Số bản ghi thất bại <span class="font-bold">{{ failedCount }}</span> bản ghi
      </div>
      <div class="mt-1">
        <b-button
          variant="outline-danger"
          :disabled="failedCount === 0 || isLoading"
          @click="downloadErrorHandle"
          >Tải bản ghi thất bại</b-button
        >
      </div>
    </div>
    <template #modal-footer>
      <div class="">
        <b-button variant="primary" class="float-right" @click="isShow = false">
          Xác nhận
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import { DownloadFileError } from '@/services/customer-support/task'
  import { showMess } from '@/config/utils'
  import moment from 'moment'
  import FileDownload from 'js-file-download'

  export default {
    name: 'ShowImage',
    components: {
      // UpdateAFS,
    },
    data() {
      return {
        isShow: false,
        isLoading: false,
        successCount: 0,
        failedCount: 0,
        dataErrors: null,
      }
    },

    methods: {
      show({ successCount, failedCount, dataErrors }) {
        this.isShow = true
        this.successCount = successCount
        this.failedCount = failedCount
        this.dataErrors = dataErrors
      },

      close() {
        this.isShow = false
      },

      async downloadErrorHandle() {
        try {
          this.isLoading = true
          const res = await DownloadFileError(this.dataErrors)
          FileDownload(res, `error_task_${moment().format('YYYYMMDDHHmmss')}.xlsx`)
        } catch (e) {
          showMess(
            this,
            'Thông báo',
            e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },
      onClose() {
        if (this.successCount) this.$emit('close')
      },
    },
  }
</script>

<style scoped></style>
